import {CustomerApplicationMenuData} from './customer-application-menu-data';
import {ApplicationMenuItemDef} from '../main/routing/application-menu-item-def';

export const CustomerApplicationMenu: ApplicationMenuItemDef[] = [
  {data: CustomerApplicationMenuData.welcome},
  {data: CustomerApplicationMenuData.insuranceSubscription},
  {data: CustomerApplicationMenuData.creditSubscription},
  {data: CustomerApplicationMenuData.investmentSubscription},
];
